export enum CustomBrandingType {
  StandardMessage,
  InvoiceMessage,
  QuoteMessage,
  GuestPortalMessage,
  VendorTaskMessage,
  InvoiceLogo,
}
